<template>
  <div class="warp_contrainer">
    <div class="search_container">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="待入库" name="3"> </el-tab-pane>
        <el-tab-pane label="已入库" name="7"></el-tab-pane>
        <el-tab-pane label="已出库" name="8"></el-tab-pane>
      </el-tabs>
      <div>
        <el-form :inline="true">
          <el-form-item label="">
            <el-input
              v-model="search.boxNumber"
              style="width: 150px"
              placeholder="合箱编码"
              clearable
              @clear="init()"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="search.vipCode"
              style="width: 150px"
              placeholder="用户VIP号"
              clearable
              @clear="init()"
            ></el-input>
          </el-form-item>

          <el-form-item label="">
            <el-select
              v-model="search.batchNum"
              style="width: 255px; padding-right: 6px"
              remote
              @change="batchChange"
              @clear="clearChecked"
              :remote-method="remoteMethod"
              reserve-keyword
              filterable
              :loading="loading"
              clearable
              placeholder="批次"
            >
              <el-option
                v-for="item in batchList"
                :key="item.sendId"
                :label="item.remark"
                :value="item.remark"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="">
            <el-select
              v-model="search.deliveryTitle"
              clearable
              placeholder="派送点"
              @change="init()"
              @clear="init()"
              style="width: 150px"
            >
              <el-option
                v-for="item in deliveryAddressList"
                :key="item.addressId"
                :label="item.deliveryTitle"
                :value="item.deliveryTitle"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="">
            <el-select
              v-model="search.goodType"
              clearable
              placeholder="货物类型"
              @change="init()"
              @clear="init()"
              style="width: 150px"
            >
              <el-option
                v-for="item in goodTypeSelect"
                :key="item.goodType"
                :label="item.goodName"
                :value="item.goodType"
              >
              </el-option>
            </el-select>
            <el-button style="margin-left: 20px" @click="init()" type="primary"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table_container">
      <el-table
        :data="dataList"
        border
        style="width: 100%"
        stripe
        row-key="boxId"
        max-height="550px"
        ref="table"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="35"
          align="center"
          :selectable="selectable"
          :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column
          prop="boxNumber"
          label="合箱编码"
          align="center"
          width="180px"
        >
        </el-table-column>
        <el-table-column label="货物类型" align="center" width="120px">
          <template slot-scope="scope">
            <span class="tag" v-if="scope.row.goodType == 1"> 海运 </span>
            <span class="tag tag1" v-else-if="scope.row.goodType == 2">
              海运大件
            </span>
            <span class="tag tag3" v-else-if="scope.row.goodType == 3">
              空运
            </span>
          </template>
        </el-table-column>
        <el-table-column label="订单数量" align="center" width="120px">
          <template slot-scope="scope">
            {{ scope.row.orderCount }}
          </template>
        </el-table-column>
        <el-table-column label="用户VIP号" align="center" width="100px">
          <template slot-scope="scope">
            {{ scope.row.vipCodes }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="订单号" align="center">
          <template slot-scope="scope">
            {{ scope.row.vipCodes }}
          </template>
        </el-table-column> -->
        <el-table-column
          label="批次"
          prop="sendRemark"
          min-width="180px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="箱号"
          prop="boxNumber"
          min-width="180px"
          align="center"
        >
        </el-table-column>
        
        <el-table-column label="派送点" align="left" width="260px">
          <template slot-scope="scope">
            <h4>{{ scope.row.deliveryTitle }}</h4>
            {{ scope.row.address }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100px">
          <template slot-scope="scope">
            {{ strStatus(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="outHanlder(scope.row)"
              v-if="scope.row.status == 3"
              >签收入库</el-button
            >
            <el-button
              type="text"
              @click="outBoxHanlder(scope.row)"
              v-if="scope.row.status == 7"
              >出库</el-button
            >
            <el-button type="text" @click="viewHandler(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="footer">
        <div
          class="footer_left"
          v-if="activeName == '7' && accountObj.roleId == 1"
        >
          <el-button type="primary" size="small" @click="outBoxHanlder(null)"
            >批量出库</el-button
          >
        </div>
        <div class="footer_left" v-if="activeName == '3'">
          <el-button type="primary" size="small" @click="intoBoxHanlder(null)"
            >批量入库</el-button
          >
        </div>
        <div class="footer_pagination">
          <el-pagination
            :page-sizes="paginations.page_sizes"
            :page-size="paginations.page_size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page="paginations.page_index"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 签收入库-->
    <el-dialog
      :visible.sync="viewDialog.show"
      :title="viewDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="900px"
      center
    >
      <div class="order_main">
        <div class="order_base">
          <div class="l_item">
            <span class="l_label">合箱编号：</span
            ><span class="l_value">{{
              viewDialog.boxInfo ? viewDialog.boxInfo.boxNumber : ""
            }}</span>
            <span class="l_label">派送点：</span
            ><span class="l_value">{{
              viewDialog.boxInfo ? viewDialog.boxInfo.deliveryTitle : ""
            }}</span>
            <span class="l_label">合箱时间：</span
            ><span class="l_value">{{
              viewDialog.boxInfo
                ? toDate(viewDialog.boxInfo.createTime, "yyyy-MM-dd hh:mm:ss")
                : ""
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">订单状态：</span
            ><span class="l_value">待入库</span>
            <span class="l_label">订单数量：</span
            ><span class="l_value">{{
              viewDialog.boxInfo ? viewDialog.boxInfo.orderCount : ""
            }}</span>
            <span class="l_label">预估费用：</span
            ><span class="l_value"
              >CAD
              {{
                viewDialog.boxInfo ? viewDialog.boxInfo.totalFreight : ""
              }}</span
            >
          </div>
          <div class="l_item">
            <span style="font-weight: 600">用户VIP号：</span
            ><span>{{
              viewDialog.boxInfo ? viewDialog.boxInfo.vipCodes : ""
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">货柜号：</span>
            <el-input
              style="width: 300px"
              placeholder="输入货柜号"
              v-model="viewDialog.boxContainerNumber"
            ></el-input>
            <span class="l_tip">（中转站签收可不填）</span>
          </div>
        </div>
        <div class="order_detail">
          <div style="text-align: center">
            <span style="font-weight: bolder; font-size: 16px">订单清单</span>
          </div>
          <div class="product_list">
            <el-table :data="viewDialog.list" border style="width: 100%" stripe>
              <el-table-column label="名称" min-width="200px" align="left">
                <template slot-scope="scope">
                  {{ scope.row.productName }}
                </template>
              </el-table-column>
              <el-table-column
                label="客户"
                prop="realName"
                min-width="70px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.realName }}
                </template>
              </el-table-column>
              <el-table-column
                label="vip号"
                prop="vipCode"
                min-width="60px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.vipCode }}
                </template>
              </el-table-column>
              <el-table-column
                label="物流公司"
                prop="expressCompany"
                min-width="80px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="运单号"
                prop="expressNo"
                min-width="125px"
                align="left"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-popconfirm title="您确定吗？" @confirm="submit" @onConfirm="submit"> -->
          <el-button slot="reference" type="primary" style="margin-right: 20px" @click="submit"
            >提 交</el-button
          >
        <!-- </el-popconfirm> -->
        <el-button @click="viewDialog.show = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!--查看详情 -->
    <el-dialog
      :visible.sync="detailDialog.show"
      :title="detailDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="1100px"
      center
    >
      <div class="order_main">
        <div class="order_base">
          <div class="l_item">
            <span class="l_label">合箱编号：</span
            ><span class="l_value">{{
              detailDialog.boxInfo ? detailDialog.boxInfo.boxNumber : ""
            }}</span>
            <span class="l_label">订单数量：</span
            ><span class="l_value">{{
              detailDialog.boxInfo ? detailDialog.boxInfo.deliveryTitle : ""
            }}</span>
            <span class="l_label">货物类型：</span
            ><span class="l_value">{{
              detailDialog.boxInfo
                ? stringGoodType(detailDialog.boxInfo.goodType)
                : ""
            }}</span>
            <span style="font-weight: 600">用户VIP号：</span
            ><span>{{
              detailDialog.boxInfo ? detailDialog.boxInfo.vipCodes : ""
            }}</span>
          </div>
        </div>
        <div class="order_detail">
          <div class="product_list">
            <el-table
              :data="detailDialog.list"
              border
              style="width: 100%"
              stripe
            >
              <el-table-column type="index" align="center" label="#">
              </el-table-column>
              <el-table-column label="名称" width="180px" align="left">
                <template slot-scope="scope">
                  {{ scope.row.productName }}
                </template>
              </el-table-column>
              <el-table-column
                label="货物类型"
                prop="goodType"
                min-width="90px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ stringGoodType(scope.row.goodType) }}
                </template>
              </el-table-column>
              <el-table-column
                label="客户"
                prop="realName"
                min-width="70px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.realName }}
                </template>
              </el-table-column>
              <el-table-column
                label="vip号"
                prop="vipCode"
                min-width="80px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.vipCode }}
                </template>
              </el-table-column>
              <el-table-column
                label="物流公司"
                prop="expressCompany"
                min-width="80px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="运单号"
                prop="expressNo"
                min-width="100px"
                align="left"
              >
              </el-table-column>
              <el-table-column
                label="商品价值"
                prop="predictTotal"
                width="80px"
                align="left"
              >
              </el-table-column>
              <el-table-column
                label="状态"
                prop="status"
                width="70px"
                align="left"
              >
                <template slot-scope="scope">
                  <span class="status1" v-if="scope.row.status == 1"
                    >待入库</span
                  >
                  <span class="status2" v-else-if="scope.row.status == 2"
                    >（国内）已入库</span
                  >
                  <span class="status3" v-else-if="scope.row.status == 3"
                    >（国内）已出库</span
                  >
                  <span class="status4" v-else-if="scope.row.status == 4"
                    >已结单</span
                  >
                  <span class="status-1" v-else-if="scope.row.status == -1"
                    >已取消</span
                  >
                  <span class="status7" v-else-if="scope.row.status == 7"
                    >(中心仓)已入库</span
                  >
                  <span class="status8" v-else-if="scope.row.status == 8"
                    >(中心仓)已出库</span
                  >
                  <span class="status9" v-else-if="scope.row.status == 9"
                    >(派送)已入库</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="运费(CAD)"
                prop="total"
                width="95px"
                align="left"
              >
              </el-table-column>
              <el-table-column
                label="下单时间"
                prop="addTime"
                width="100px"
                align="left"
              >
                <template slot-scope="scope">
                  {{ toDate(scope.row.addTime, "yyyy-MM-dd hh:mm:ss") }}
                </template>
              </el-table-column>
              <el-table-column
                label="派送点"
                prop="deliveryTitle"
                width="100px"
                align="left"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog.show = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 出库 -->
    <el-dialog
      :visible.sync="outDialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div style="text-align: center">
        <p>{{ outDialog.content }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="outSubmit()" v-if="outDialog.boxId"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="batchOutSubmit()"
          v-if="!outDialog.boxId"
          >确 定</el-button
        >
        <el-button type="default" @click="outDialog.show = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <!-- 批量入库 -->
    <el-dialog
      :visible.sync="intoDialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div style="text-align: center">
        <p>{{ intoDialog.content }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchIntoSubmit()">确 定</el-button>
        <el-button type="default" @click="intoDialog.show = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as deliveryApi from "@/api/delivery";
import * as order from "@/api/order";
import { axios } from "utils/";
import * as date from "utils/date";
import * as StringUtils from "utils/StringUtils";
import * as boxApi from "@/api/box";
export default {
  data() {
    return {
      multipleSelection: [],
      activeName: "3",
      viewDialog: {
        show: false,
        title: "签收入库",
        boxId: null,
        boxContainerNumber: null,
        boxInfo: {},
        list: [],
      },
      detailDialog: {
        show: false,
        title: "查看详情",
        boxId: null,
        boxInfo: {},
        list: [],
      },
      outDialog: {
        show: false,
        content: "您确定出库吗？",
        boxId: null,
      },
      intoDialog: {
        show: false,
        content: "您确定入库吗？",
        boxId: null,
      },
      search: {
        boxNumber: "",
        deliveryTitle: "",
        vipCode: "",
        goodType: null,
        orderNumber: null,
        batchNum: "",
      },
      goodTypeSelect: [
        {
          goodType: 1,
          goodName: "海运",
        },
        {
          goodType: 2,
          goodName: "海运大件",
        },
        {
          goodType: 3,
          goodName: "空运",
        },
      ],
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 20, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      dataList: [], //列表
      deliveryAddressList: [],
      accountObj: null,
      // 批次列表
      batchList: [],
      // 批次的时间 节流
      timeout: null,
      loading:false,
    };
  },
  created() {
    let that = this;
    that.getBoxList();
    that.getDeliveryList();
    let accountObj = JSON.parse(localStorage.getItem("userinfo"));
    this.accountObj = accountObj;
    this.getBatchList();
  },
  methods: {
    init() {
      this.paginations.page_index = 1;
      this.getBoxList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectable(row, index) {
      if (this.activeName == "7") {
        return true;
      } else if (this.activeName == "3") {
        return true;
      } else {
        return false;
      }
    },
    handleClick(tab, event) {
      this.$refs.table.clearSelection();
      this.getBoxList();
    },
    getBoxList(size, page) {
      let that = this;
      let param = {};
      param.pageIndex = that.paginations.page_index;
      param.pageSize = that.paginations.page_size;
      param.status = that.activeName;
      param.goodType = that.search.goodType;
      param.boxNumber = that.search.boxNumber;
      param.vipCode = that.search.vipCode;
      param.orderNumber = that.search.orderNumber;
      param.batchNumber = that.search.batchNum
        ? that.search.batchNum.trim()
        : "";

      param.deliveryTitle = that.search.deliveryTitle;
      if (page) {
        param.pageIndex = page;
        that.paginations.page_index = page;
      }
      boxApi.boxList(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.dataList = res.data.data.list || [];
        that.paginations.total = res.data.data.pageCount;
      });
    },
    submit() {
      //分拨入库提交
      let that = this;
      let param = {};
      param.boxId = this.viewDialog.boxId;
      param.status = 7;
      param.type = 1;
      param.boxContainerNumber = that.viewDialog.boxContainerNumber;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      boxApi.allocationCentrePut(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success",
        });
        that.getBoxList();
        that.viewDialog.show = false;
      });
    },
    outSubmit() {
      //出库
      let that = this;
      let param = {};
      param.boxId = this.outDialog.boxId;
      param.status = 8;
      param.type = 1;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      boxApi.boxDelivery(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success",
        });
        that.getBoxList();
        that.outDialog.show = false;
      });
    },
    batchOutSubmit() {
      //批量出库
      let that = this;
      if (
        that.multipleSelection == null ||
        that.multipleSelection.length == 0
      ) {
        this.$message.error("请选择");
        return;
      }
      let param = {};
      param.status = 8;
      let boxPojos = [];
      that.multipleSelection.forEach((item) => {
        let obj = {};
        obj.boxId = item.boxId;
        obj.status = 8;
        boxPojos.push(obj);
      });
      param.boxPojos = boxPojos;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      boxApi.volumeDelivery(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success",
        });
        that.getBoxList();
        that.outDialog.show = false;
      });
    },
    // 批量出库
    outBoxHanlder(row) {
      if (row != null) {
        this.outDialog.show = true;
        this.outDialog.boxId = row.boxId;
        this.outDialog.content = "您确定出库吗？";
      } else {
        if (
          this.multipleSelection == null ||
          this.multipleSelection.length == 0
        ) {
          this.$message.error("请选择");
          return;
        }
        this.outDialog.show = true;
        this.outDialog.boxId = null;
        this.outDialog.content = "您确定批量出库吗？";
      }
    },
    // 批量入库弹框显示
    intoBoxHanlder(row) {
      if (row != null) {
        this.intoDialog.show = true;
        this.intoDialog.boxId = row.boxId;
        this.intoDialog.content = "您确定入库吗？";
      } else {
        if (
          this.multipleSelection == null ||
          this.multipleSelection.length == 0
        ) {
          this.$message.error("请选择");
          return;
        }
        this.intoDialog.show = true;
        this.intoDialog.boxId = null;
        this.intoDialog.content = "您确定批量入库吗？";
      }
    },

    batchIntoSubmit() {
      //批量入库提交
      let that = this;
      if (
        that.multipleSelection == null ||
        that.multipleSelection.length == 0
      ) {
        this.$message.error("请选择");
        return;
      }
      let param = {};
      param.status = 7;
      let boxPojos = [];
      that.multipleSelection.forEach((item) => {
        boxPojos.push(item.boxId);
      });
      param.boxIds = boxPojos;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      boxApi.mulIntoStore(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success",
        });
        that.getBoxList();
        that.intoDialog.show = false;
      });
    },

    // 签收入库
    outHanlder(row) {
      this.viewDialog.boxId = row.boxId;
      this.getBoxInfo();
      this.viewDialog.show = true;
    },
    viewHandler(row) {
      this.detailDialog.boxId = row.boxId;
      this.getBoxDetail();
      this.detailDialog.show = true;
    },
    getBoxInfo() {
      let that = this;
      let param = {};
      param.boxId = that.viewDialog.boxId;
      boxApi.allocationCentreInformation(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.viewDialog.boxInfo = res.data.data;
        that.viewDialog.boxContainerNumber = that.viewDialog.boxInfo
          ? that.viewDialog.boxInfo.boxContainerNumber
          : "";
        that.viewDialog.list = res.data.data.orderPojoList || [];
      });
    },
    getBoxDetail() {
      let that = this;
      let param = {};
      param.boxId = that.detailDialog.boxId;
      boxApi.boxDetails(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.detailDialog.boxInfo = res.data.data;
        that.detailDialog.list = res.data.data.orderPojoList || [];
      });
    },
    stringGoodType(goodType) {
      return StringUtils.goodType(goodType);
    },
    strStatus(status) {
      let str = "";
      switch (status) {
        case 3:
          str = "待入库";
          break;
        case 7:
          str = "已入库";
          break;
        case 8:
          str = "已出库";
          break;
      }
      return str;
    },
    toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;

      that.getBoxList(page_size, "1");
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getBoxList();
    },

    getDeliveryList() {
      let that = this;
      let data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then((res) => {
        if (res.data.code != 0) {
          return;
        }
        if (res.data.code == 0) {
          that.deliveryAddressList = res.data.data.list;
        }
      });
    },

    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },

    // 清除所选批次
    clearChecked() {
      this.getBatchList();
      this.init();
    },

    batchChange() {
      this.init();
    },

    // 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },
  },
};
</script>
<style scoped lang="less">
.warp_contrainer {
  padding: 3px 20px;
}
.order_main {
  .order_base {
    margin-bottom: 20px;
    .l_item {
      padding: 6px 0;
      font-size: 12px;
      span {
        display: inline-block;
      }
      .l_label {
        width: 80px;
        text-align: right;
        font-weight: 600;
      }
      .l_value {
        width: 200px;
      }
    }
  }
  .order_detail {
    .title {
      padding-bottom: 10px;
      border-bottom: 1px solid #e1e1e1;
      .name {
        font-size: 15px;
        font-weight: bold;
      }
    }
    .product_list {
      margin-top: 20px;
    }
  }
}
.footer {
  width: 100%;
  margin: 20px 0 50px 0;
  position: relative;
  .footer_pagination {
    position: absolute;
    right: 0;
    top: 0;
    left: 200px;
    margin-top: 0;
    text-align: right;
  }
}
.tag {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 4px;
  background-color: #d2d2da;
  border-color: #e9e9eb;
  color: #909399;
  &.tag1 {
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }
  &.tag2 {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  &.tag3 {
    background-color: #fae1be;
    border-color: #faecd8;
    color: #e6a23c;
  }
}
</style>



// WEBPACK FOOTER //
// order.vue?0c79ac0f